/** 官方素材列表分页批次大小（Admin / 用户端共用） */
export const IPE_LAZY_LIST_BATCH_SIZE = 200;

/** 通用图片：默认即时加载；仍保留 immediate=false 供极长页可选 */
export const IPE_LAZY_IMAGE_ROOT_MARGIN = '400px';

export const ADMIN_OFFICIAL_SCROLL_ROOT = '.admin-shell__main';

export const IPE_HOME_GALLERY_SCROLL_ROOT = '.funding-workbench--home .funding-workbench__main-body';

export const IPE_MAT_HUB_SCROLL_ROOT = '.mat-hub__body';

/** 工作台主内容滚动区（图片空间等） */
export const IPE_WORKBENCH_MAIN_SCROLL_ROOT = '.funding-workbench__main-body';

/** 素材采集列表表格滚动容器 */
export const IPE_SOURCING_MATERIAL_SCROLL_ROOT = '.wf-tasks-page.sourcing-hub .wf-tasks-table-wrap';

/** 素材采集缩略图：提前更远距离开始加载 */
export const IPE_SOURCING_MATERIAL_IMAGE_ROOT_MARGIN = '480px';

/** 采集详情商品网格 · 工作台主滚动区 */
export const IPE_SOURCING_PRODUCT_GRID_SCROLL_ROOT = '.funding-workbench__main-body';
